import { Context } from '@/context/appContext';
import { AppStateActions } from '@/reducers/appReducer';
import { Button } from '@/components/ui/button';
import { DialogBody, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { EmailForm } from './EmailForm';
import { GoogleButton } from './GoogleButton';
import { LegalInfo } from './LegalInfo';

export function AuthView() {
  const { t } = useTranslation('web', { keyPrefix: 'components.AuthModal' });
  const {
    state: { authState },
    dispatch,
  } = useContext(Context);

  const isSignIn = authState.state === 'SIGN_IN';

  const handleToggleState = () =>
    dispatch({
      type: AppStateActions.SET_AUTH_STATE,
      payload: { state: isSignIn ? 'SIGN_UP' : 'SIGN_IN', force: authState.force },
    });

  const title = authState.force
    ? isSignIn
      ? t('forceSignIn')
      : t('forceSignUp')
    : isSignIn
      ? t('signInHeader')
      : t('signUpHeader');

  return (
    <>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>

      <DialogBody className="flex flex-col gap-4">
        <GoogleButton />

        <div className="flex items-center gap-3">
          <span className="h-px flex-1 bg-divider" />
          <span className="text-mono-eyebrow">{t('or')}</span>
          <span className="h-px flex-1 bg-divider" />
        </div>

        <EmailForm />
        <LegalInfo />
      </DialogBody>

      <DialogFooter>
        <span className="text-ui text-muted-foreground">{isSignIn ? t('noAccount') : t('haveAccount')}</span>
        <Button variant="link" size="sm" className="px-0" onClick={handleToggleState}>
          {isSignIn ? t('signUp') : t('signIn')}
        </Button>
      </DialogFooter>
    </>
  );
}
